import React, { useState } from 'react';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../../components/ui/dialog';

export default function ShiftModal({ open, onClose, onOpen }) {
  const [startingCash, setStartingCash] = useState('0');

  const handleOpen = () => {
    onOpen(parseFloat(startingCash) || 0);
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="bg-card border-border max-w-sm" data-testid="shift-modal">
        <DialogHeader>
          <DialogTitle>Open Shift</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div>
            <label className="text-sm text-muted-foreground">Starting Cash Float</label>
            <Input type="number" value={startingCash} onChange={e => setStartingCash(e.target.value)}
                   placeholder="0.00" className="bg-muted border-border"
                   data-testid="starting-cash-input" />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Cancel</Button>
          <Button onClick={handleOpen} className="bg-secondary hover:bg-secondary/90" data-testid="confirm-open-shift-btn">
            Open Shift
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
